import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { getAccessToken, getWebshopSettings, isTokenExpired } from "../../api/session";
import { ResourceError } from "../utils/ResourceError";
import { ResourceLoading } from "../utils/ResourceLoading";
import initializeInterceptor from "./interceptor";

export default function PersistLogin(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  async function initializeAuth() {
    try {
      // Get initial token (will fetch new one if expired or missing)
      const token = await getAccessToken();
      
      if (!token) {
        throw new Error("No token received");
      }
      
      console.log("Token initialized successfully");
      
      // Initialize interceptors with token
      initializeInterceptor(token);
      
      setIsLoading(false);
    } catch (err) {
      console.error("Failed to initialize authentication:", err);
      if (err.response) {
        console.error("Response status:", err.response.status);
        console.error("Response data:", err.response.data);
      }
      setError("Kunne ikke autentisere. Vennligst last siden på nytt.");
      setIsLoading(false);
    }
  }

  async function getSettings() {
    try {
      const settings = await getWebshopSettings();
      if (settings && settings.data) {
        localStorage.setItem("settings", JSON.stringify(settings.data));
        return settings.data;
      }
    } catch (err) {
      console.error("Failed to load settings:", err);
      // Don't block the app if settings fail to load
    }
  }

  useEffect(() => {
    // Initialize authentication
    initializeAuth();
    
    // Load settings after a short delay to ensure token is set
    const settingsTimer = setTimeout(() => {
      getSettings();
    }, 500);

    // Set up periodic token refresh check (every 5 minutes)
    const tokenCheckInterval = setInterval(() => {
      if (isTokenExpired()) {
        // Token is expired or about to expire, refresh it proactively
        getAccessToken(true).catch((err) => {
          console.error("Proactive token refresh failed:", err);
        });
      }
    }, 5 * 60 * 1000); // Check every 5 minutes

    return () => {
      clearTimeout(settingsTimer);
      clearInterval(tokenCheckInterval);
    };
  }, []);

  if (isLoading) return <ResourceLoading />;
  if (error) return <ResourceError message={error} />;

  return <Outlet />;
}
